import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, SingleWellCultureByCycleCodeController, SingleWellCultureByCycleCodeRequest, IvfOocyteEmbryoStorageByCodeController, IvfOocyteEmbryoStorageByCodeRequest, CycleOocyteQualityBetweenDateController, CycleOocyteQualityBetweenDateRequest, IvfEmbryoGradingByCycleController, IvfEmbryoGradingByCycleRequest, IvfCycleEmbryoTransferrablesController, IvfCycleEmbryoTransferrablesRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { OocyteStoreItem } from '../../../testnurse/ivf/ivfworkbench/ivfoqaedit.component';
import { EmbryoStoreItem } from '../../../testnurse/ivf/ivfworkbench/ivfgradingedit.component';




@Component({
  selector: 'cryostoragedroplet',
  templateUrl: './cryostoragedroplet.component.html',
  styleUrls: ['./cryostoragedroplet.component.scss']
})

export class CryostorageDropletPVComponent implements OnInit {

  //@Input() CycleCode: number;
  //@Input() TitleText: string;
  //@Input() DOC: string;

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public EndometriumThickness: number;
  public LeftOvaries: number;
  public RightOvaries: number;
  public MedicineName: string;
  public TestName: string;
  public TestName1: string;
  public Owner: string;
  public FormattedCode: string;
  public Protocolst: string;
  public ProtocolEd: string;
  public Protocol: string;
  public Infertility: string;
  public Gender: string;
  public Age: string;
  public CycleNo: string;
  public CycleType: string;
  public TotalOocytes: string;
  public Date: Date;
  public TransferedCount: number;
  public FrozenCount: number;
  public DiscardedCount: number;
  public TotalCout: number;
  public TreatmentCycleCodedata: any;

  public Frozen: number;
  public length: number;
  public ActorCodedata: any;
  public EggSourceType: string;
  public EggSourceData: string;
  public DonorData: string;
  public DonorCode: string;

  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  ScanDate: NgbDateStruct;
  SelectedFromDate: NgbDateStruct;
  public Doc: string;
  public DocDate: string;

  CurrentIvfEmbryoGradingByCycleController: IvfEmbryoGradingByCycleController[];
  CurrentIvfEmbryoGradingByCycleRequest: IvfEmbryoGradingByCycleRequest;

  LoadGradingData() {
    //alert("ScansData")
    this.CurrentIvfEmbryoGradingByCycleRequest = new IvfEmbryoGradingByCycleRequest();

    this.CurrentIvfEmbryoGradingByCycleRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfEmbryoGradingByCycleController();
  }
 
  GetIvfEmbryoGradingByCycleController() {

    this.CurrentIvfEmbryoGradingByCycleRequest.ConditionalOperator = 10;
    this.CurrentIvfEmbryoGradingByCycleRequest.CycleCode = this.TreatmentCycleCodedata;


    this.actorservice.GetIvfEmbryoGradingByCycleController(this.CurrentIvfEmbryoGradingByCycleRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentIvfEmbryoGradingByCycleController = this.ApiResData.Result;

          this.stopRefreshing();
          this.LoadGradingData2();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  CurrentIvfCycleEmbryoTransferrablesController: IvfCycleEmbryoTransferrablesController[];
  CurrentIvfCycleEmbryoTransferrablesRequest: IvfCycleEmbryoTransferrablesRequest;

  LoadGradingData2() {
    //alert("ScansData")
    this.CurrentIvfCycleEmbryoTransferrablesRequest = new IvfCycleEmbryoTransferrablesRequest();

    this.CurrentIvfCycleEmbryoTransferrablesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleEmbryoTransferrablesController();
  }

  GetIvfCycleEmbryoTransferrablesController() {
    //  alert(this.DOC);
    this.CurrentIvfCycleEmbryoTransferrablesRequest.ConditionalOperator = 10;
    this.CurrentIvfCycleEmbryoTransferrablesRequest.CycleCode = this.TreatmentCycleCodedata;

    this.actorservice.GetIvfCycleEmbryoTransferrablesController(this.CurrentIvfCycleEmbryoTransferrablesRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentIvfCycleEmbryoTransferrablesController = this.ApiResData.Result;

          this.stopRefreshing();
          this.LoadGradingData3();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentIvfCycleEmbryoTransferrablesControllerByActor: IvfCycleEmbryoTransferrablesController[];
  CurrentIvfCycleEmbryoTransferrablesRequestByActor: IvfCycleEmbryoTransferrablesRequest;

  LoadGradingData3() {
    //alert("ScansData")
    this.CurrentIvfCycleEmbryoTransferrablesRequestByActor = new IvfCycleEmbryoTransferrablesRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentIvfCycleEmbryoTransferrablesRequestByActor.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetIvfCycleEmbryoTransferrablesController2();
  }

  GetIvfCycleEmbryoTransferrablesController2() {
    //  alert(this.DOC);
    this.CurrentIvfCycleEmbryoTransferrablesRequestByActor.ConditionalOperator = 20;
    this.CurrentIvfCycleEmbryoTransferrablesRequestByActor.ActorCode = this.ActorCodedata;
    //if (this.EggSourceType == 'Donor') {
    //  this.CurrentIvfCycleEmbryoTransferrablesRequestByActor.ActorCode = this.ActorCodedata;
    //}
    //else if (this.EggSourceType == 'Self') {
    //  this.CurrentIvfCycleEmbryoTransferrablesRequestByActor.ActorCode = this.ActorCodedata;
    //}

    // this.CurrentIvfEmbryoGradingByCycleRequest.DOC = "";


    this.actorservice.GetIvfCycleEmbryoTransferrablesController(this.CurrentIvfCycleEmbryoTransferrablesRequestByActor)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          this.CurrentIvfCycleEmbryoTransferrablesControllerByActor = this.ApiResData.Result;

          this.stopRefreshing();
          this.LoadPatients();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  CurrentCycleOocyteQualityBetweenDateController: CycleOocyteQualityBetweenDateController[];
  CurrentCycleOocyteQualityBetweenDateRequest: CycleOocyteQualityBetweenDateRequest;
  LoadPatients() {
    this.CurrentCycleOocyteQualityBetweenDateRequest = new CycleOocyteQualityBetweenDateRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentCycleOocyteQualityBetweenDateRequest.FacilityCode = AppData.Instance().UserLoginDetails.EmpFacilityCode;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ActorCode = this.ActorCode;
    this.CurrentCycleOocyteQualityBetweenDateRequest.ConditionalOperator = 10;
    //this.CurrentCycleOocyteQualityBetweenDateRequest.FromDate = new Date(2017, 1, 1);
    //this.CurrentCycleOocyteQualityBetweenDateRequest.ToDate = new Date();

    this.CurrentCycleOocyteQualityBetweenDateRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.GetCycleOocyteQualityBetweenDateController();
  }

  GetCycleOocyteQualityBetweenDateController() {
    this.StartRefreshing();


    this.actorservice.GetCycleOocyteQualityBetweenDateController(this.CurrentCycleOocyteQualityBetweenDateRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentCycleOocyteQualityBetweenDateController = this.ApiResData.Result;
          //this.pdata = this.CurrentCycleOocyteQualityBetweenDateController;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.printService.onDataReady();
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {
    //alert("in scans comp");
    this.Date = new Date();

    this.Doc = this.route.snapshot.paramMap.get('Doc');
    this.DocDate = this.route.snapshot.paramMap.get('DocDate');
    this.Owner = this.route.snapshot.paramMap.get('Owner');
    this.FormattedCode = this.route.snapshot.paramMap.get('PatientId');
    this.Protocolst = this.route.snapshot.paramMap.get('ProtocolStart');
    this.ProtocolEd = this.route.snapshot.paramMap.get('ProtocolEnd');
    this.Protocol = this.route.snapshot.paramMap.get('Protocol');
    this.Infertility = this.route.snapshot.paramMap.get('Infertility');
    this.Gender = this.route.snapshot.paramMap.get('Gender');
    this.Age = this.route.snapshot.paramMap.get('Age');
    this.CycleNo = this.route.snapshot.paramMap.get('CycleNo');
    this.CycleType = this.route.snapshot.paramMap.get('CycleType');
    this.TotalOocytes = this.route.snapshot.paramMap.get('TotalOocytes');
    this.TreatmentCycleCodedata = this.route.snapshot.paramMap.get('TreatmentCycleCodedata');
    this.ActorCodedata = this.route.snapshot.paramMap.get('ActorCodedata');
    this.EggSourceType = this.route.snapshot.paramMap.get('EggSourceType');
    this.EggSourceData = this.route.snapshot.paramMap.get('EggSourceData');
    this.DonorData = this.route.snapshot.paramMap.get('DonorData');
    this.DonorCode = this.route.snapshot.paramMap.get('DonorCode');

    this.LoadGradingData();

  }



  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}








